const c = {
  success: "check-circle",
  warning: "alert-circle"
};
export {
  c as STATE_VARIANT_MAPPER
};
